var map = {
	"./chests-2.png": 134,
	"./chests.png": 135,
	"./no-chests.png": 136,
	"./srwrds-chest-anim.png": 137,
	"./srwrds-flare-tierup.png": 347,
	"./srwrds-flare.png": 348,
	"./srwrds-glint-tierup.png": 349,
	"./srwrds-glint.png": 350,
	"./srwrds-particles-tierup.png": 351,
	"./srwrds-particles.png": 352,
	"./srwrdsBoost_Complete.ogg": 353,
	"./srwrdsBoost_Start.ogg": 354,
	"./srwrdsChest_Unlocked.ogg": 355,
	"./srwrdsChest_Unlocked_tu.ogg": 356,
	"./stars-rewards-open-chest-anim-108px.png": 357,
	"./stars.png": 358,
	"./starsreward_chest_open@2x.png": 133,
	"./starsrewards-icons.svg": 359,
	"./tier-up-anim-large.png": 360,
	"./tier-up-anim-sparkles.png": 361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 346;